module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d8e3d221"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e3221"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c6.5_r1#d7e1",
      "id": "d6e1"
    }
  }, [_vm._v("Pennsylvania Dutch Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e5811"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c7_r1#d7e2",
      "id": "d6e2"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e25231"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c8_r1#d7e3",
      "id": "d6e3"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e49511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c9_r1#d7e4",
      "id": "d6e4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e75811"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c10_r1#d7e5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e100001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c11_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e126241"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c12_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e145851"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c13_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e165871"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c14_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e184511"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c15_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e214741"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c16_r1#d7e11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e237171"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c17_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e254371"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c18_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e270921"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c19_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e289961"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c20_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e309351"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c21_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e323261"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c22_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e341481"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c23_r1#d7e18",
      "id": "d6e18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e359551"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c24_r1#d7e19",
      "id": "d6e19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e379751"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c25_r1#d7e20",
      "id": "d6e20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e393021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c26_r1#d7e21",
      "id": "d6e21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e401041"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c27_r1#d7e22",
      "id": "d6e22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e403751"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c28_r1#d7e23",
      "id": "d6e23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Group Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e409741"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c30_r1#d7e24",
      "id": "d6e24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author to Author")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d8e428501"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Wise_9781401685553_epub_c35_r1#d7e25",
      "id": "d6e25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d03d79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wise_9781401685553_epub_c6_r1.vue
// module id = 72
// module chunks = 0